// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*COPIED FROM CONFLUENCE*/

#charmap-picker {
	border: 0;
	font-size: 16px;
	font-family: Arial, Helvetica, FreeSans, sans-serif;
	padding: 2px;
	text-align: center;
}

#charmap-view {
	padding-right: 1em;
	text-align: left;
	vertical-align: top;
}

#charmap-info {
	text-align: center;
	vertical-align: top;
	width: 100%;
}

#charmap-info > table {
	border: 0;
	height: 100px;
	padding: 0;
	width: 100%;
}

#code-value {
	font-size: 3em;
}

#code-name {
	font-size: 13px;
}

#code-value,
#code-name {
	color: var(--ds-text-subtle, #666);
	text-align: center;
}

.charmap a:link,
.charmap a:visited,
.charmap a:active,
.charmap a:hover {
	color: var(--ds-link-pressed, #326ca6);
	text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./../confluence-editor/src/editor-plugins/confcharmap/charmap.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;CACC,SAAS;CACT,eAAe;CACf,mDAAmD;CACnD,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,SAAS;CACT,aAAa;CACb,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;;CAEC,kCAAkC;CAClC,kBAAkB;AACnB;;AAEA;;;;CAIC,sCAAsC;CACtC,qBAAqB;AACtB","sourcesContent":["/*COPIED FROM CONFLUENCE*/\n\n#charmap-picker {\n\tborder: 0;\n\tfont-size: 16px;\n\tfont-family: Arial, Helvetica, FreeSans, sans-serif;\n\tpadding: 2px;\n\ttext-align: center;\n}\n\n#charmap-view {\n\tpadding-right: 1em;\n\ttext-align: left;\n\tvertical-align: top;\n}\n\n#charmap-info {\n\ttext-align: center;\n\tvertical-align: top;\n\twidth: 100%;\n}\n\n#charmap-info > table {\n\tborder: 0;\n\theight: 100px;\n\tpadding: 0;\n\twidth: 100%;\n}\n\n#code-value {\n\tfont-size: 3em;\n}\n\n#code-name {\n\tfont-size: 13px;\n}\n\n#code-value,\n#code-name {\n\tcolor: var(--ds-text-subtle, #666);\n\ttext-align: center;\n}\n\n.charmap a:link,\n.charmap a:visited,\n.charmap a:active,\n.charmap a:hover {\n\tcolor: var(--ds-link-pressed, #326ca6);\n\ttext-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
